import Link from "next/link";
import type { ModuleMetadata } from "@/config/modules";

interface ModuleCardProps {
  module: ModuleMetadata;
  badge?: number;
  span?: 1 | 2 | 3;
}

const SPAN_CLASS: Record<1 | 2 | 3, string> = {
  1: "",
  2: "col-span-2",
  3: "col-span-3",
};

export function ModuleCard({ module, badge, span = 1 }: ModuleCardProps) {
  const Icon = module.icon;
  const wide = span > 1;

  return (
    <Link
      href={module.href}
      className={`block h-full ${SPAN_CLASS[span]}`}
    >
      <div
        className={`group relative flex h-full rounded-2xl border border-border bg-card px-3 transition-colors duration-200 hover:border-white/15 hover:bg-secondary active:bg-muted ${
          wide
            ? "items-center gap-3 py-3"
            : "min-h-[112px] flex-col gap-2 pt-3.5 pb-3"
        }`}
      >
        {badge !== undefined && badge > 0 && (
          <span className="absolute -right-1.5 -top-1.5 flex size-5 items-center justify-center rounded-full bg-primary text-11 font-bold text-primary-foreground">
            {badge > 9 ? "9+" : badge}
          </span>
        )}

        <div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-primary/15">
          <Icon className="size-[15px] text-primary" />
        </div>

        <div className={`min-w-0 space-y-0.5 ${wide ? "flex-1" : "mt-auto"}`}>
          <h3 className="text-xs font-semibold leading-[1.25] text-foreground">
            {module.title}
          </h3>
          {module.shortDescription && (
            <p className="text-2xs leading-[1.3] text-muted-foreground/70">
              {module.shortDescription}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
}
